import { render, staticRenderFns } from "./ReportRushLabel.vue?vue&type=template&id=2e72486d&scoped=true&"
import script from "./ReportRushLabel.vue?vue&type=script&lang=js&"
export * from "./ReportRushLabel.vue?vue&type=script&lang=js&"
import style0 from "./ReportRushLabel.vue?vue&type=style&index=0&id=2e72486d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e72486d",
  null
  
)

export default component.exports
import {QIcon} from 'quasar'
component.options.components = Object.assign({QIcon}, component.options.components || {})
